import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";
import { ContractorTradeTermAddEdit } from "./ContractorTradeTermAddEdit";

export class ContractorTradeTerm extends ContractorTradeTermAddEdit {
  @Expose()
  @IsString()
  id!: string;

  @Expose()
  @IsNumber()
  recordStampId!: number;
}
